import React, { useEffect, useState } from 'react';
import { Form, Input, Popconfirm, Table, Typography, Button, Select, Upload, message } from 'antd';
import { CloseOutlined, DeleteOutlined, EditFilled, FilePdfOutlined, InboxOutlined, SaveFilled, VerticalAlignTopOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title } = Typography;

const ModifiedUploadFile = ({ value, onChange }) => {
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        // Set fileList dari prop value jika ada
        if (value && value.fileList) {
            setFileList(value.fileList);
        }
    }, [value]);

    const uploadProps = {
        name: 'file',
        accept: '.pdf',
        maxCount: 1,
        fileList: fileList,
        beforeUpload: (file) => {
            // Validasi tipe file
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                message.error('Hanya file PDF yang dapat diunggah!');
                return Upload.LIST_IGNORE;
            }

            // Update fileList
            const newFileList = [
                {
                    uid: '-1',
                    name: file.name,
                    status: 'done',
                    originFileObj: file,
                }
            ];

            setFileList(newFileList);

            // Panggil onChange dan kembalikan file data
            if (onChange) {
                const formData = new FormData();
                formData.append('file', file);

                onChange({
                    fileList: newFileList,
                    file: file,
                    fileName: file.name,
                    formData: formData
                });
            }

            // Prevent default upload action
            return false;
        },
        onRemove: () => {
            setFileList([]);
            if (onChange) {
                onChange(undefined);
            }
            return true;
        },
    };

    return (
        <Upload.Dragger {...uploadProps} customRequest={() => { }}>
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag a PDF file to this area to upload</p>
            <p className="ant-upload-hint">
                Support for a single PDF file upload only. You can replace the file if needed.
            </p>
        </Upload.Dragger>
    );
};

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {

    return (
        <td {...restProps}>
            {editing ? (
                <div>

                    {dataIndex === 'FileUpload' ? (
                        <Form.Item
                            name={dataIndex}
                            style={{
                                margin: 0,
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: `Please Input ${title}!`,
                                    // Validator khusus untuk file
                                    validator: (_, value) => {
                                        if (!value || !value.file) {
                                            return Promise.reject(new Error('Please upload a file!'));
                                        }
                                        return Promise.resolve();
                                    }
                                },
                            ]}
                            getValueFromEvent={(e) => {
                                // Handle nilai dari upload component
                                if (Array.isArray(e)) {
                                    return e;
                                }
                                return e && e.fileList ? e : e;
                            }}
                        >
                            <ModifiedUploadFile />
                        </Form.Item>

                    ) : (

                        <Form.Item
                            name={dataIndex}
                            label={title}
                            rules={[
                                {
                                    required: true,
                                    message: `Please Input ${title}!`,
                                },
                            ]}
                        >
                            {dataIndex === 'DocType' && editing ? (
                                <Select
                                    allowClear
                                    options={[
                                        // {
                                        //     value: 'REPORT',
                                        //     label: 'REPORT',
                                        // },
                                        {
                                            value: 'FAKTUR',
                                            label: 'FAKTUR',
                                        },
                                        {
                                            value: 'FAKTUR PAJAK',
                                            label: 'FAKTUR PAJAK',
                                        },
                                        // {
                                        //     value: 'BUKTI BAYAR',
                                        //     label: 'BUKTI BAYAR',
                                        // },
                                    ]}
                                    placeholder={title}
                                />
                            ) : (
                                <Input placeholder={title} />
                            )}
                        </Form.Item>
                    )}

                </div>
            ) : (
                children
            )
            }
        </td >
    );
};


const TableFormUpload = ({ onSaveData, onEditData, onEditDetail }) => {

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    // console.log('No', count);

    const [editingKey, setEditingKey] = useState('');

    useEffect(() => {
        if (onEditData && onEditData.length > 0) {
            const fetchDocs = async () => {
                const payload = onEditData.map((item, index) => ({
                    ...item,
                    key: index + 1,
                    FileUpload: `${process.env.REACT_APP_BASEURL}/${item.PathName}`,
                    NameFile: item.PathName,
                }));
                setData(payload);
                setCount(payload.length > 0 ? payload[payload.length - 1].key : 0);
            };
            fetchDocs();
        }
    }, [onEditData]);


    const isEditing = (record) => record.key === editingKey;

    const handleEdit = (record) => {

        const DocType = record.DocType ? record.DocType : [];

        form.setFieldsValue({
            Description: '',
            ...record,
            DocType: DocType,
        });
        setEditingKey(record.key);
    };


    const handleDelete = (key) => {
        const deletedRow = data.find((row) => row.key === key);
        if (!deletedRow) return; // Hindari error jika key tidak ditemukan

        const deletedNumber = deletedRow.key;

        const newData = data.filter((row) => row.key !== key);

        const updatedData = newData.map((row) => {
            if (row.key > deletedNumber) {
                return { ...row, key: row.key - 1 };
            }
            return row;
        });

        setCount(updatedData.length > 0 ? updatedData[0].key : 0);
        setData(updatedData);

        if (typeof onSaveData === "function") {
            onSaveData(updatedData);
        } else {
            console.error("onSaveData is not a function or is undefined.");
        }
    };



    const handleCancel = (record) => {
        if (record.key) {
            const newData = data.filter((item) => item.key !== record.key);
            setData(newData);
        } else {
            setEditingKey(null);
        }
        setEditingKey(null);

        // console.log("DataFormTran", data);
    };


    const handleSave = async (record) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => record.key === item.key);

            let fileData = null;
            let fileName = row.FileName || '';

            if (row.FileUpload && row.FileUpload.file) {
                fileData = row.FileUpload.file;
                fileName = row.FileUpload.fileName || fileData.name;
            }

            if (index > -1) {
                newData[index] = { ...newData[index], ...row, FileData: fileData, FilePath: fileName };
            } else {
                newData.push({ ...row, FileData: fileData, FilePath: fileName });
            }

            setData(newData);
            setEditingKey(null);

            if (onSaveData) {
                onSaveData(newData);
            } else {
                console.error("onSaveData is not defined!");
            }

            const editedRow = data.find((row) => row.key === record.key);
            const lastNumber = editedRow.key;

            setCount(lastNumber);
        } catch (err) {
            console.log('Validate Failed:', err);
        }
    };



    const handleAdd = () => {

        const num = count + 1;

        const newData = {
            key: num,
            FileUpload: "",
            FilePath: "",
            FileName: "",
            DocType: "",
        };
        setData([newData, ...data]);
        handleEdit(newData);

        // console.log("DataFormTran", data);
    };

    // const handleSaveAllData = async () => {
    //     setLoading(true);
    //     try {
    //         onSaveData(data);
    //         console.log("PostData", data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    //     setLoading(false);
    // }

    // const handleCancelAllData = () => {
    //     setData([]);
    //     setCount(0);
    //     onSaveData([]);
    // }

    const columns = [
        {
            dataIndex: 'key',
            title: '#',
            key: 'key',
            sorter: (a, b) => a.key - b.key,
        },
        {
            key: 'FileName',
            title: 'File Name',
            dataIndex: 'FileName',
            editable: true,
            render: (value, record) => {
                if (!onEditDetail) {
                    return value;
                } else {
                    return (
                        <Link
                            to={record.FileUpload}
                            target="_blank"
                            className="text-blue-500"
                        >
                            {value}
                        </Link>
                    )
                }
            }
        },
        {
            key: 'DocType',
            title: 'Documnet Type',
            dataIndex: 'DocType',
            editable: true,
        },
    ];

    if (!onEditDetail) {
        columns.splice(1, 0, {
            key: 'FileUpload',
            title: 'File Upload',
            dataIndex: 'FileUpload',
            editable: true,
            render: (value, record) => {
                const fileName = record.NameFile?.split("_").slice(1).join("_") || value;
                if (record.FileData) {
                    return (
                        <div>
                            <FilePdfOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
                            {record.FilePath}
                        </div>
                    );
                } else {
                    return (
                        <Link
                            to={record.FileUpload}
                            target="_blank"
                            className="text-blue-500"
                        >
                            <FilePdfOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
                            {fileName}
                        </Link>
                    );
                }
            }
        });
    }

    if (!onEditDetail) {
        columns.push({
            title: 'Actions',
            dataIndex: 'actions',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                        <Typography.Link onClick={() => handleSave(record)}>
                            <Button icon={<SaveFilled />} type="text" />
                        </Typography.Link>

                        <Typography.Link onClick={() => handleCancel(record)}>
                            <Button icon={<CloseOutlined />} type="text" />
                        </Typography.Link>
                    </span>
                ) : (
                    <span style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                        <Typography.Link onClick={() => handleEdit(record)}>
                            <Button icon={<EditFilled />} type="text" />
                        </Typography.Link>
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                            <Link>
                                <Button icon={<DeleteOutlined />} type="text" />
                            </Link>
                        </Popconfirm>
                    </span>
                );
            },
        });
    }


    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
            ...col,
        };
    });

    return (
        <Form form={form} component={false}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "0 10px 10px"
                }}
            >
                <Title level={3} style={{ margin: "0" }}>
                    DOCUMENTS
                </Title>

                {!onEditDetail && (
                    <Button
                        onClick={handleAdd}
                        type="primary"
                        htmlType="button"
                        disabled={!!editingKey}
                    >
                        <VerticalAlignTopOutlined /> Upload Document
                    </Button>
                )}
            </div>
            <Table
                components={{
                    body: {
                        cell: EditableCell,
                    },
                }}
                // bordered
                dataSource={data}
                columns={mergedColumns}
                rowClassName="editable-row"
                pagination={{
                    onChange: handleCancel,
                    pageSize: 5,
                }}
            />
            {/* <div
                style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                    margin: "10px 10px 0"
                }}
            >
                <Popconfirm title="Sure to clear all data?" onConfirm={handleCancelAllData}>
                    <Button
                        type="button"
                        color="error"
                        variant="contained"
                        disabled={!!editingKey || !!isDisable}
                    >
                        <span>Cancel</span>
                    </Button>
                </Popconfirm>
                <LoadingButton
                    color="primary"
                    onClick={handleSaveAllData}
                    loading={loading}
                    variant="contained"
                    disabled={!!editingKey || !!isDisable}
                >
                    <span>Save</span>
                </LoadingButton>

            </div> */}
        </Form>
    );
};
export default TableFormUpload;
